export const LXP_SEARCH_FG = 'lxpsearch';
